module.exports = __webpack_public_path__ + "compatibility-testing.qud1L27D.svg";